import { GraphQLClient } from 'graphql-request';
import { print } from 'graphql';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** NaiveDate */
  NaiveDate: any;
  /** Uuid */
  Uuid: any;
};

export type AdditionalInfoInput = {
  gender?: Maybe<Scalars['String']>;
  birthday?: Maybe<Scalars['NaiveDate']>;
  zipcode?: Maybe<Scalars['String']>;
  dropdown?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  desiredStartDate?: Maybe<Scalars['NaiveDate']>;
  languagesSpoken?: Maybe<Array<Scalars['String']>>;
  employmentType?: Maybe<EmploymentType>;
  inputLinkedin?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  experience?: Maybe<Experience>;
  insures?: Maybe<Array<Scalars['String']>>;
  npi?: Maybe<Scalars['String']>;
  bacbCertificationNumber?: Maybe<Scalars['String']>;
};

export type AdminMutation = {
  __typename?: 'AdminMutation';
  giveAdminAccess: Scalars['Boolean'];
  withdrawAdminAccess: Scalars['Boolean'];
  migrateToGreenhouse: Scalars['String'];
};


export type AdminMutationGiveAdminAccessArgs = {
  emailAddress: Scalars['String'];
};


export type AdminMutationWithdrawAdminAccessArgs = {
  emailAddress: Scalars['String'];
};


export type AdminMutationMigrateToGreenhouseArgs = {
  candidateId: Scalars['Uuid'];
};

export type AdminQuery = {
  __typename?: 'AdminQuery';
  getAnswers?: Maybe<CandidateAnswers>;
  getGreenhouseLink?: Maybe<Scalars['String']>;
};


export type AdminQueryGetAnswersArgs = {
  candidateId: Scalars['Uuid'];
};


export type AdminQueryGetGreenhouseLinkArgs = {
  candidateId: Scalars['Uuid'];
};

export type Answer = {
  __typename?: 'Answer';
  id?: Maybe<Scalars['Uuid']>;
  formulation?: Maybe<Scalars['String']>;
};

export type Candidate = {
  __typename?: 'Candidate';
  id: Scalars['Uuid'];
  firstName: Scalars['String'];
  middleName?: Maybe<Scalars['String']>;
  surname: Scalars['String'];
  level?: Maybe<Level>;
  state?: Maybe<State>;
  priority?: Maybe<Priority>;
  phone?: Maybe<Scalars['String']>;
  emailAddress: Scalars['String'];
  gender?: Maybe<Scalars['String']>;
  birthday?: Maybe<Scalars['NaiveDate']>;
  zipcode?: Maybe<Scalars['String']>;
  dropdown?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  desiredStartDate?: Maybe<Scalars['NaiveDate']>;
  languagesSpoken?: Maybe<Array<Scalars['String']>>;
  employmentType?: Maybe<EmploymentType>;
  experience?: Maybe<Experience>;
  inputLinkedin?: Maybe<Scalars['String']>;
  isAdmin: Scalars['Boolean'];
  insures?: Maybe<Array<Scalars['String']>>;
  /** National Provider Identifier */
  npi?: Maybe<Scalars['String']>;
  /** Behavior Analyst Certification Board Number */
  bacbCertificationNumber?: Maybe<Scalars['String']>;
  appliedTime?: Maybe<Scalars['Float']>;
  /** Is present in greenhouse */
  isPresent: Scalars['Boolean'];
};

export type CandidateAnswer = {
  __typename?: 'CandidateAnswer';
  id: Scalars['Uuid'];
  question: Scalars['String'];
  answer: Scalars['String'];
};

export type CandidateAnswers = {
  __typename?: 'CandidateAnswers';
  score: Scalars['Float'];
  allScore: Scalars['Float'];
  questionsAnswers: Array<CandidateAnswer>;
};

export type CandidateAuthInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type CandidateMutation = {
  __typename?: 'CandidateMutation';
  add: Candidate;
  authenticate: Scalars['Boolean'];
  logout: Scalars['Boolean'];
  clarify: Candidate;
  setState: Candidate;
  requestResetPassword: Scalars['Boolean'];
  resetPassword: Scalars['Boolean'];
};


export type CandidateMutationAddArgs = {
  input: CandidateSummaryInput;
};


export type CandidateMutationAuthenticateArgs = {
  input: CandidateAuthInput;
};


export type CandidateMutationClarifyArgs = {
  input: AdditionalInfoInput;
};


export type CandidateMutationSetStateArgs = {
  input: State;
};


export type CandidateMutationRequestResetPasswordArgs = {
  emailAddress: Scalars['String'];
};


export type CandidateMutationResetPasswordArgs = {
  input: CandidateResetPasswordInput;
};

export type CandidateQuery = {
  __typename?: 'CandidateQuery';
  get: Candidate;
};


export type CandidateQueryGetArgs = {
  candidateId?: Maybe<Scalars['Uuid']>;
};

export type CandidateResetPasswordInput = {
  resetToken: Scalars['String'];
  newPassword: Scalars['String'];
};

export type Candidates = {
  __typename?: 'Candidates';
  candidates: Array<CandidateSummary>;
  count: Scalars['Int'];
};

export type CandidatesQuery = {
  __typename?: 'CandidatesQuery';
  get: Candidates;
};


export type CandidatesQueryGetArgs = {
  input: CandidatesRequest;
};

export type CandidatesRequest = {
  filter?: Maybe<Filter>;
  prioritizer?: Maybe<Prioritizer>;
  sorter?: Maybe<Sorter>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};

export type CandidateSummary = {
  __typename?: 'CandidateSummary';
  id: Scalars['Uuid'];
  name: Scalars['String'];
  level?: Maybe<Level>;
  zipcode?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  stateLocation?: Maybe<Scalars['String']>;
  emailAddress?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  inputLinkedin?: Maybe<Scalars['String']>;
  experience?: Maybe<Experience>;
  priority?: Maybe<Priority>;
};

export type CandidateSummaryInput = {
  firstName: Scalars['String'];
  middleName?: Maybe<Scalars['String']>;
  lastName: Scalars['String'];
  emailAddress: Scalars['String'];
  zipcode: Scalars['String'];
  level: Level;
};

export enum EmploymentType {
  FullTime = 'FULL_TIME',
  PartTime = 'PART_TIME'
}

/** Experience of candidate */
export enum Experience {
  ExperienceLessThanOneYear = 'EXPERIENCE_LESS_THAN_ONE_YEAR',
  ExperienceOneTwoYear = 'EXPERIENCE_ONE_TWO_YEAR',
  ExperienceThreeFourYear = 'EXPERIENCE_THREE_FOUR_YEAR',
  ExperienceFivePlusYear = 'EXPERIENCE_FIVE_PLUS_YEAR'
}

export type Filter = {
  name?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  level?: Maybe<Level>;
};

export enum Level {
  LevelRbt = 'LEVEL_RBT',
  LevelBcba = 'LEVEL_BCBA',
  LevelBtToRbt = 'LEVEL_BT_TO_RBT'
}

export type Mutation = {
  __typename?: 'Mutation';
  candidates: CandidateMutation;
  quiz: QuizMutation;
  admin: AdminMutation;
};


export type Prioritizer = {
  zipcodes?: Maybe<Array<Scalars['String']>>;
  cities?: Maybe<Array<Scalars['String']>>;
  states?: Maybe<Array<Scalars['String']>>;
};

export enum Priority {
  PriorityOne = 'PRIORITY_ONE',
  PriorityTwo = 'PRIORITY_TWO',
  PriorityThree = 'PRIORITY_THREE',
  PriorityFour = 'PRIORITY_FOUR',
  PriorityNone = 'PRIORITY_NONE'
}

export type Query = {
  __typename?: 'Query';
  admin: AdminQuery;
  candidates: CandidatesQuery;
  candidate: CandidateQuery;
  quiz: QuizQuery;
};

export type QuestionAnswersInput = {
  id: Scalars['Uuid'];
  answers?: Maybe<Array<Scalars['Uuid']>>;
  freeAnswer?: Maybe<Scalars['String']>;
};

export type QuestionFormulation = {
  __typename?: 'QuestionFormulation';
  id: Scalars['Uuid'];
  index: Scalars['Int'];
  formulation: Scalars['String'];
  isFreeForm: Scalars['Boolean'];
  answers?: Maybe<Array<Answer>>;
};

export type QuestionsGroup = {
  __typename?: 'QuestionsGroup';
  prefix?: Maybe<Scalars['String']>;
  questions: Array<QuestionFormulation>;
};

export type QuizMutation = {
  __typename?: 'QuizMutation';
  resolve: Candidate;
};


export type QuizMutationResolveArgs = {
  level?: Maybe<Level>;
  input: Array<QuestionAnswersInput>;
};

export type QuizQuery = {
  __typename?: 'QuizQuery';
  get: Array<QuestionsGroup>;
};


export type QuizQueryGetArgs = {
  level?: Maybe<Level>;
};

export enum Sorter {
  Priority = 'PRIORITY',
  PriorityReverse = 'PRIORITY_REVERSE',
  City = 'CITY',
  CityReverse = 'CITY_REVERSE',
  State = 'STATE',
  StateReverse = 'STATE_REVERSE',
  Experience = 'EXPERIENCE',
  ExperienceReverse = 'EXPERIENCE_REVERSE'
}

export enum State {
  PersonalInfo = 'PERSONAL_INFO',
  Quiz = 'QUIZ',
  BackgroundCheck = 'BACKGROUND_CHECK',
  Done = 'DONE'
}


export type RegisterMutationVariables = Exact<{
  input: CandidateSummaryInput;
}>;


export type RegisterMutation = (
  { __typename?: 'Mutation' }
  & { candidates: (
    { __typename?: 'CandidateMutation' }
    & { add: (
      { __typename?: 'Candidate' }
      & Pick<Candidate, 'id'>
    ) }
  ) }
);


export const RegisterDocument = gql`
    mutation Register($input: CandidateSummaryInput!) {
  candidates {
    add(input: $input) {
      id
    }
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: () => Promise<T>) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = sdkFunction => sdkFunction();
export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    Register(variables: RegisterMutationVariables, requestHeaders?: Headers): Promise<RegisterMutation> {
      return withWrapper(() => client.request<RegisterMutation>(print(RegisterDocument), variables, requestHeaders));
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;